import React, { memo } from 'react';
import styled from 'styled-components';

const Profile = memo(
  ({ iconSize = 40, imageId, style, title = '', name = '' }) => {
    return (
      <ContainerDiv
        iconSize={iconSize}
        style={style}
        url={imageId && `https://s3-ap-northeast-1.amazonaws.com/s3.mplf.net/${imageId}%3Fsize%3D200`}
        title={title}
      >
        <a />
        {!!name && <p className="ellipsis">{name}</p>}
      </ContainerDiv>
    );
  }
);

export default Profile;

//#region styles
const ContainerDiv = styled.div`
  display: flex;
  align-items: center;

  & > {
    a {
      display: block;
      width: ${props => `${props.iconSize}px`};
      height: ${props => `${props.iconSize}px`};
      border-radius: 100%;
      box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
      background: url(/img/tmp/dummyIcon_L.png) no-repeat;
      background-size: cover;
      background-position: center;
      overflow: hidden;

      &:after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        background: url(${props => props.url}) no-repeat;
        background-size: cover;
        background-position: center;
      }
    }

    p {
      flex: 1;
      padding-left: 8px;
      line-height: 1.8;
    }
  }
`;
//#endregion
